import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import ActionButton from '@/components/Button/ActionButton';
import { FillScreen, HStack } from '@/components/Layout';
import { SettingsHeader } from '@/components/Settings/SettingsHeader';
import { useDeviceGroupsList } from '@/features/device-group/query';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { LIST_EMPTY_DATA } from '@/lib/listPage';
import { DataTableCard } from './-components/DataTableCard';
import { ListSearchBar } from './-components/ListSearchBar';
import { SearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/devices/_list/settings/device-groups/')({
  validateSearch: zodValidator(SearchSchema),
  component: RouteComponent
});
function RouteComponent() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.devices.settings.deviceGroups.list'
  });
  useDocumentTitle(t('pageTitle'));
  const search = Route.useSearch();
  const navigate = useNavigate({
    from: '/devices/settings/device-groups'
  });
  const {
    data: listRes,
    isPending
  } = useDeviceGroupsList({
    search: search.freeText,
    page: search.pageIndex + 1,
    pageSize: search.pageSize,
    orderBy: search.sortColumn,
    orderDirection: search.sortOrder
  });
  return <FillScreen className="flex min-h-0 flex-col gap-4 pb-6">
      <HStack className="gap-6 py-6">
        <SettingsHeader icon="GroupIcon" title={t('title')} description={t('description')} />
        <ActionButton icon="PlusIcon" className="bg-primary-fill" onClick={() => navigate({
        to: '/devices/device-groups/new'
      })}>
          {t('createButton')}
        </ActionButton>
      </HStack>

      <ListSearchBar search={search} navigate={navigate} />

      <DataTableCard search={search} navigate={navigate} listRes={listRes ?? LIST_EMPTY_DATA} isPending={isPending} />
    </FillScreen>;
}